import {buildWebsocketUrl, snakeToCamel} from 'utils/common';

export default class SocketBase {
  static _socket = null;

  constructor({url, socketClass = SocketBase}) {
    this.url = url;
    this.connect = this.connect.bind(this);
    this.disconnect = this.disconnect.bind(this);
    this.onMessage = this.onMessage.bind(this);
    this.onClose = this.onClose.bind(this);
    this.processData = this.processData.bind(this);

    if (socketClass._socket) {
      this.socket = socketClass._socket;
    } else {
      this.connect();
    }
  }

  connect() {
    this.socket = new WebSocket(buildWebsocketUrl(this.url, {jwt: localStorage.getItem('kluwellJwt')}));
    this.socket.addEventListener('message', this.onMessage);
    this.socket.addEventListener('close', this.onClose);
  }

  disconnect() {
    if (!this.socket) return;
    this.socket.removeEventListener('message', this.onMessage);
    this.socket.removeEventListener('close', this.onClose);
    this.socket.close();
  }

  onMessage(event) {
    const data = snakeToCamel(JSON.parse(event.data));
    this.processData(data);
  }

  onClose() {
    setTimeout(this.connect, 3000);
  }

  processData() {
    throw Error('method processData must be implemented');
  }
}
